import React from "react";
import {
  Container,
  ContainerWrapper,
  HeaderContainer,
  Title,
  HeaderContainerInner,
} from "./styles";
import PerformanceGrid from "./PerformanceGrid";
import { Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import goToHelpLink from "../../../utils/goToHelpLink";

// 생산실적 페이지
function Performance() {
  return (
    <Container>
      <HeaderContainer>
        <HeaderContainerInner>
          <Title>생산실적</Title>
          <Tooltip
            title="이동"
            sx={{ cursor: "pointer" }}
            onClick={() =>
              goToHelpLink(
                "http://esehelp.cafe24.com/scheduler#h-5-%EC%83%9D%EC%82%B0%EC%8B%A4%EC%A0%81-%ED%8E%98%EC%9D%B4%EC%A7%80"
              )
            }
          >
            <HelpOutlineIcon />
          </Tooltip>
        </HeaderContainerInner>
      </HeaderContainer>
      <ContainerWrapper>
        <PerformanceGrid />
      </ContainerWrapper>
    </Container>
  );
}

export default Performance;
